import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { Duration, LoyaltyExpiryConfiguration, WalletExpiryConfiguration } from "../../models/model";
import { FormControl, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";

export interface WalletExpiryType {
  displayName: string;
  type: "DURATION" | "FIXED_DATE" | "DEFAULT" | "NO_EXPIRY";
}
@Component({
  selector: "app-wallet-expiry-configuration",
  templateUrl: "./wallet-expiry-configuration.component.html",
  styleUrls: [
    "./wallet-expiry-configuration.component.css",
    "../../../modules/pos/modules/offer/pages/gift-code-creation/gift-code-creation.component.css",
  ],
})
export class WalletExpiryConfigurationComponent implements OnInit {
  @Input() walletExpiryConfiguration: WalletExpiryConfiguration;
  @Input() type: "wallet" | "loyalty";
  @Input() loyaltyExpiryConfig: LoyaltyExpiryConfiguration;

  walletExpiryDate = new FormControl('', Validators.required);
  startDateMinValue;
  isClicked: boolean = false
  walletDuration: Duration = {
    value: 0,
    unit: "DAYS",
  };
  walletExpiryType: "DURATION" | "FIXED_DATE" | "DEFAULT" | "NO_EXPIRY" =
    "DEFAULT";

  walletExpiryTypes: WalletExpiryType[] = [
    {
      displayName: "Default Expiry",
      type: "DEFAULT",
    },
    {
      displayName: "No Expiry",
      type: "NO_EXPIRY",
    },
    {
      displayName: "Valid for",
      type: "DURATION",
    },
    {
      displayName: "Valid till",
      type: "FIXED_DATE",
    },
  ];

  constructor(
    private datePipe: DatePipe,
    private tokenStorage: TokenStorageService
  ) {}

  ngOnInit(): void {
    let currentDate = new Date();
    this.startDateMinValue = new Date(
      currentDate.toLocaleString("en-US", {
        timeZone: this.tokenStorage.getMerchantTimeZone(),
      })
    );
  }

  
  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.walletExpiryConfiguration);
    if (changes.walletExpiryConfiguration || changes.loyaltyExpiryConfig) {
      this.fetchAndPrefillData();
    }
  }

  fetchAndPrefillData() {
    if (this.walletExpiryConfiguration && this.type === "wallet") {
      this.walletExpiryDate.setValue(
        this.walletExpiryConfiguration.validityDate
      );
      this.walletDuration = this.walletExpiryConfiguration.duration;
      this.walletExpiryType = this.walletExpiryConfiguration.expiryType;
    } else if(this.loyaltyExpiryConfig && this.type === "loyalty") {
      this.walletExpiryDate.setValue(
        this.loyaltyExpiryConfig?.validityDate?.replace(" ", "T")
      );
      this.walletDuration.value = this.loyaltyExpiryConfig.duration;
      this.walletDuration.unit = this.loyaltyExpiryConfig.timeFrame;
      this.walletExpiryType = this.loyaltyExpiryConfig.expiryType;
    }
  }

  getExpirationData() {
    console.log("TESTTT", this.type);
    this.isClicked = true;
    if (
      this.walletExpiryType === "DURATION" &&
      (!this.walletDuration.value || this.walletDuration.value <= 0)
    ) {
      return this.handleValidationError(
        "Duration must be greater than 0.",
        "DURATION"
      );
    }

    if (
      this.walletExpiryType === "FIXED_DATE" &&
      !this.walletExpiryDate.value
    ) {
      return ;
    }

    // if (
    //   this.walletExpiryType === "FIXED_DATE" &&
    //   new Date(this.walletExpiryDate.value) < new Date()
    // ) {
    //   return this.handleValidationError(
    //     "Validity date cannot be in the past.",
    //     "FIXED_DATE"
    //   );
    // }
    if(this.type === "wallet") {
      const walletExpiryConfiguration: WalletExpiryConfiguration = {
        expiryType: this.walletExpiryType,
        duration: this.walletDuration,
        validityDate: this.walletExpiryDate?.value
          ? this.datePipe.transform(this.walletExpiryDate?.value, "yyyy-MM-dd")
          : null,
        defaultExpiry: this.walletExpiryType === "DEFAULT" ? true : null,
        noExpiry: this.walletExpiryType === "NO_EXPIRY" ? true : null,
      };
      return walletExpiryConfiguration;
    } else{
      let validityDate = null;
      if (this.walletExpiryDate.value) {
        let date = new Date(this.walletExpiryDate.value);
        date.setHours(23, 59, 59, 999);
        validityDate = this.datePipe.transform(date, "yyyy-MM-dd'T'HH:mm:ss");
      }
      const loyaltyExpiryConfiguration: LoyaltyExpiryConfiguration = {
        expiryType: this.walletExpiryType,
        duration: this.walletExpiryType === "DURATION" ? this.walletDuration.value : null,
        validityDate: this.walletExpiryDate?.value
          ? validityDate
          : null,
        defaultExpiry: this.walletExpiryType === "DEFAULT" ? true : null,
        timeFrame: this.walletExpiryType === "DURATION" ? this.walletDuration.unit : null,
      };
      return loyaltyExpiryConfiguration;
    }
  }

  handleValidationError(message: string, field: "DURATION" | "FIXED_DATE") {
    console.error(`Validation Error: ${message}`);
    const errorElement = document.getElementById(`${field}-error`);
    if (errorElement) {
      errorElement.textContent = message; // Display the error message
    }
    if (field === "DURATION") {
    } else if (field === "FIXED_DATE") {
      this.walletExpiryDate.setErrors({ invalid: true }); // Mark validity date as invalid
    }
    return null;
  }

  keypressNumber(event) {
    this.handleValidationError("", "DURATION");
    if (
      [46, 8, 9, 27, 13].includes(event.keyCode) ||
      // Allow: Ctrl+A/Ctrl+C/Ctrl+V/Ctrl+X
      (event.keyCode === 65 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      (event.keyCode === 67 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      (event.keyCode === 86 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      (event.keyCode === 88 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
      (event.keyCode >= 35 && event.keyCode <= 40)
    ) {
      // Let it happen, don't do anything
      return;
    }
    // Ensure that it's a number and stop the keypress if it's not
    if (
      (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }

}
